import { INotification } from '../../models/interfaces/INotification';
import { NotificationAction, SET_NOTIFICATION } from '../actionTypes/notificationTypes';

export const setNotification = (notification: INotification): NotificationAction => {
    return {
        type: SET_NOTIFICATION,
        payload: notification
    };
};
